export enum PaymentsErrorCodes {
  REQUEST_ORG_MISMATCH = 'payment_request_org_mismatch',
  INITIATOR_REQUEST_ERROR = 'initiator_request_error',
  PAYMENT_REQUEST_FORBIDDDEN = 'payment_request_forbidden',
  PAYMENT_APPROVER_FORBIDDDEN = 'payment_approver_forbidden',
  PAYMENT_INITIATOR_FORBIDDDEN = 'payment_initiator_forbidden',
  PAYMENT_READER_FORBIDDDEN = 'payment_reader_forbidden',
  PAYMENT_REQUEST_ALREADY_PROCCESSED = 'payment_request_already_proccessed',
  PAYMENT_OWN_REQUEST_ERROR = 'payment_own_request_error',
  PAYMENT_INVALID_ROLE_ERROR = 'payment_invalid_role_error',
  ALL_PAYMENT_REQUESTS_FAILED = 'all_payment_requests_failed',
  PAYMENT_RECORD_NOT_FOUND = 'payment_record_not_found',
  PAYMENT_SUMMARY_NOT_FOUND = 'payment_summary_not_found',
  INSUFFICIENT_BALANCE = 'insufficient_balance',
  TARGET2_BIC_AND_ADDRESS_REQUIRED = 'target2bic_and_address_required',
  EXCEEDED_TRANSFER_LIMIT = 'exceeded_transfer_limit',
  PAYMENT_REQUEST_FAILED = 'payment_request_failed',
  INVALID_AMOUNT = 'invalid_amount',
  AMOUNT_TOO_LOW = 'amount_too_low',
  PAYMENT_FAILED_BIC_REQUIRED = 'payment_failed_bic_required',
  PAYMENT_FAILED_ADDRESS_REQUIRED = 'payment_failed_address_required',
  CUSTOMER_IS_NOT_ENROLLED = 'customer_is_not_enrolled',
  SCHEDULED_PAYMENT_CANCELLED_FAILED = 'scheduled_payment_cancelled_failed',
  PAYMENTS_CANCELLED_FAILED = 'payments_cancelled_failed',
  EQUALS_EXCHANGE_NEXT_TRADING_DAY_REQUIRED = 'equals_exchange_next_trading_day_required',
  EQUALS_PAYMENT_EXCHANGE_TARGET_CURRENCY_UNRESOLVED = 'equals_payment_exchange_target_currency_unresolved',
  EQUALS_PAYMENT_EXCHANGE_UNSUPPORTED_FROM_SUB_BUDGET = 'equals_payment_exchange_unsupported_from_sub_budget',
  FAIL_WITHDRAWAL_NOTICE = 'fail-withdrawal-notice',
  DESCRIPTION_LIMIT_VALIDATION_ERROR = 'description-limit-validation-error',
}
